<template>
  <div v-if="hasLinks" class="container--is-maxwidth dynamic-links">

    <!-- Heading -->
    <div v-if="links.Title" class="dynamic-links__title">
      <h2>{{ links.Title }}</h2>
    </div>

    <!-- Items list -->
    <div class="dynamic-links__items">
      <ol>
        <li v-for="(item, i) in items" :key="i">
          <!-- NOSONAR -->
          <a
            :href="item.url"
            target="_blank"
            rel="noopener noreferrer"
            class="cta--secondary cta--light"
          >
            {{ item.text }}
          </a>
        </li>
      </ol>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DynamicLinks',

  props: {
    links: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      items: [],
      hasLinks: false,
    };
  },
  mounted() {
    this.loadLinks();
  },
  methods: {
    loadLinks() {
      // Validate incoming JSON
      const lg = this.links?.link_groups;

      if (!Array.isArray(lg) || lg.length === 0) {
        this.hasLinks = false;
        return;
      }

      const items = lg[0]?.items;

      if (!Array.isArray(items) || items.length === 0) {
        this.hasLinks = false;
        return;
      }

      // Extract items safely
      this.items = items
        .map((i) => {
          if (!i?.text || !i?.url) return null;
          return { text: i.text, url: i.url };
        })
        .filter(Boolean);

      this.hasLinks = this.items.length > 0;
    },
  },
};
</script>
<style lang="scss" src="./dynamic-links.scss"></style>
